export default __webpack_public_path__ + "assets/11c457a20ad3c2184a3a0f90fc6e01aa/preview-mobile.jpg";